import { HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SearchParams } from '@stylehaven/components';

@Injectable()
export abstract class AbstractHttpService {
    abstract head<T>(endpoint: string, params?: SearchParams | HttpParams): Observable<HttpResponse<T>>;
    abstract get<T>(endpoint: string, params?: SearchParams | HttpParams, apiVersion?: string): Observable<T>;

    abstract getBlob(endpoint: string, params?: HttpParams): Observable<Blob>;

    abstract post<T>(endpoint: string, data: any, options?: {}, apiVersion?: string): Observable<T>;
    abstract put<T>(endpoint: string, data: any, options?: {}, apiVersion?: string): Observable<T>;

    abstract delete<T>(endpoint: string): Observable<T>;
    abstract delete<T>(endpoint: string, listenForResponse: true): Observable<HttpResponse<T>>;

    abstract request<T>(endpoint: string, method: string, body: any): Observable<T>;
}
